export default __webpack_public_path__ + "static/media/Encapsulation.4a2a518c.png";